import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import {
  THealthSystemResponse,
  THealthSystemRequest,
  TAddEditHealthSystemRequest,
  THealthSystem,
  HealthSystemRequestData
} from 'features/HealthSystems/types'
import { ResponseWithPagination, VALIDATION_MESSAGES } from '../../constants'
import { THealthSystemDetails } from '../HealthSystemDetails/types'
import { THospital } from '../HealthSystemDetails/HospitalsTable/types'

const fetcher = new Fetcher({})

export const fetchHealthSystemsList = async (
  community: string,
  data?: HealthSystemRequestData
) =>
  fetcher.request<THealthSystemRequest, THealthSystemResponse>({
    url: `${API_DICTIONARY.COMMUNITIES}${community}/${API_DICTIONARY.HEALTH_SYSTEMS}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const fetchHealthSystem = async (
  communityUUID: string,
  HSUUID: string
) =>
  fetcher.request<unknown, THealthSystemDetails>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityUUID}/${API_DICTIONARY.HEALTH_SYSTEMS}${HSUUID}/`,
    method: HTTP_METHODS.GET
  })

export const fetchHospitalList = async (
  communityUUID: string,
  HSUUID: string
) =>
  fetcher.request<unknown, ResponseWithPagination<THospital>>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityUUID}/${API_DICTIONARY.HEALTH_SYSTEMS}${HSUUID}/${API_DICTIONARY.HOSPITALS}`,
    method: HTTP_METHODS.GET
  })

export const fetchHospital = async (
  communityUUID: string,
  HSUUID: string,
  hospitalUUID: string
) =>
  fetcher.request<unknown, THospital>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityUUID}/${API_DICTIONARY.HEALTH_SYSTEMS}${HSUUID}/${API_DICTIONARY.HOSPITALS}${hospitalUUID}/`,
    method: HTTP_METHODS.GET
  })

export const addHealthSystem = async (uuid, data) =>
  fetcher.request<TAddEditHealthSystemRequest, THealthSystem>({
    url: `${API_DICTIONARY.COMMUNITIES}${uuid}/${API_DICTIONARY.HEALTH_SYSTEMS}`,
    method: HTTP_METHODS.POST,
    successMessage: `Health system ${VALIDATION_MESSAGES.SM0009} added.`,
    data
  })

export const editHealthSystem = async (uuid, data, id) =>
  fetcher.request<TAddEditHealthSystemRequest, THealthSystem>({
    url: `${API_DICTIONARY.COMMUNITIES}${uuid}/${API_DICTIONARY.HEALTH_SYSTEMS}${id}/${API_DICTIONARY.UPDATE}`,
    method: HTTP_METHODS.PUT,
    successMessage: `Health system ${VALIDATION_MESSAGES.SM0009} saved.`,
    data
  })

export const fetchAllHospitals = async (
  communityUUID: string,
  health_systems?: string
) =>
  fetcher.request<unknown, ResponseWithPagination<THospital>>({
    url: `${API_DICTIONARY.COMMUNITIES}${communityUUID}/${API_DICTIONARY.HOSPITALS}`,
    method: HTTP_METHODS.GET,
    params: { health_systems }
  })
